import React, { useEffect, useState } from "react";

/**
 * Универсальный слайдер со значением по центру и подписями слева/справа.
 */
const RangeSlider = ({
    label,
    value = 0,
    min = 0,
    max = 100,
    step = 1,
    disabled = false,
    formatValue,
    leftLabel,
    rightLabel,
    onChange,
}) => {
    const toNumber = (v) => {
        const n = Number(v);
        return Number.isFinite(n) ? n : min;
    };

    const [internal, setInternal] = useState(toNumber(value));

    useEffect(() => {
        setInternal(toNumber(value));
    }, [value]);

    const handleChange = (e) => {
        const next = toNumber(e.target.value);
        setInternal(next);
        onChange?.(next, e);
    };

    const display = formatValue ? formatValue(internal) : internal;

    return (
        <div className="d-flex flex-column gap-2">
            {label && <label className="form-label fw-semibold mb-0">{label}</label>}
            <input
                type="range"
                className="form-range"
                min={min}
                max={max}
                step={step}
                value={internal}
                disabled={disabled}
                onChange={handleChange}
            />
            <div className="d-flex justify-content-between align-items-center text-muted small">
                <span>{leftLabel ?? min}</span>
                <span className="fw-semibold text-dark px-2 py-1 rounded-2 bg-white border">{display}</span>
                <span>{rightLabel ?? max}</span>
            </div>
        </div>
    );
};

export default RangeSlider;
